<template>
  <v-form ref="formConsumption" v-model="validForm" lazy-validation>
    <div>
      <v-row>
        <v-col cols="12">
          <h3>Teste de Consumo Soluções:</h3>
        </v-col>
      </v-row>
      <v-row>
        <!-- Start Table Solutions -->
        <v-data-table
          :headers="headers"
          :items="checkListObj"
          class="elevation-1"
          style="width: 100%"
        >
          <template v-slot:top>
            <v-toolbar flat class="rounded-lg">
              <v-toolbar-title>Relatório</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="mb-2"
                text
                @click="addSolutionReport()"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(report, index) in items" :key="index">
                <td>
                 <v-text-field       
                    disabled             
                    v-model="report.local" 
                    :rules="rulesRequired"
                  >
                  </v-text-field>
                </td>
                <td>
                 <v-text-field    
                    disabled                
                    v-model="report.sub_local" 
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field   
                    disabled
                    :value="convertNameType(report.type)"
                    :rules="rulesRequired"
                  />
                </td>
                <td>
                  <v-text-field
                    disabled
                    :value="convertSolutionName(report.solution)"
                    :rules="rulesRequired"
                  />
                </td>
                <td>
                  <v-text-field 
                    disabled
                    :value="report.category"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field 
                    disabled
                    :value="report.status"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field 
                    disabled
                    type="Number" 
                    v-model="report.amountSolution" 
                    :rules="rulesRequired"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                    disabled
                    type="Number"
                    v-model="report.flowRateBefore"
                    suffix="L/min"
                    :rules="rulesRequired"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                    disabled
                    type="Number"
                    v-model="report.flowRateAfter"
                    suffix="L/min"
                    :rules="rulesRequired"
                  >
                  </v-text-field>
                </td>
                <td width="90px">
                  <v-text-field
                    disabled
                    type="Number"
                    v-model="report.economy"
                    suffix="%"
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field disabled v-model="report.comments"> </v-text-field>
                </td>
                <td>
                  <v-icon :color="changeColorIconListImg(report)" small> mdi-image </v-icon>
                </td>
                <td>
                  <v-btn
                    
                    elevation="2"
                    :loading="loading.actionsSolutionList"
                    @click="confirmDeleteUnit(index)"
                    style="height: 30px; margin: 2px"
                  >
                    <v-icon color="primary" small> mdi-delete </v-icon>
                  </v-btn>
                  <v-btn
                    elevation="2"
                    :loading="loading.actionsSolutionList"
                    @click="editReportSolution(index)"
                    style="height: 30px; margin: 2px"
                  >
                    <v-icon color="primary" small> mdi-pencil </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <!-- End Table Solutions -->
      </v-row>
      <v-divider style="margin-top: 8px"></v-divider>
    </div>
    <solutionInsert 
      ref="solutionInsert"
      v-if="dialogSolution"
      :dialog="dialogSolution" 
      :closeDialog="closeDialog" 
      :id="id"
      :registration="registration"
      :editableSolution="editableSolution"
      
      :solutionsOptions="solutionsData"
      :pointsOptions="pointsData"
      
      @report:save="setSolutionReport"
    />
  </v-form>
</template>
<script>
import Rules from "@/utils/Rules";
import { showInfoSnackBar } from "@/utils/SnackBartHelper";
import solutionInsert from "@/components/FormsComponents/WaterFix/Solution";
import WaterFixService from '@/services/firebase/WaterFix/WaterFixService';
import WaterFixStorage from '@/services/storage/WaterFixStorage';
import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";
import SolutionsServices from '@/services/firebase/SolutionsServices/SolutionsServices';
import SolutionsGroup from '@/services/firebase/SolutionsGroup/SolutionsGroup';
import SolutionsPoint from '@/services/firebase/SolutionsPoint/SolutionsPoint';
import ObjectValidator from '@/scripts/ObjectValidator';
import Utils from '@/scripts/Utils';

export default {
  name: "hydrometerForm",
  props: ["requestData","solutionListItens","registration", "id"],
  components: {
    solutionInsert,
  },
  data: function () {
    return {
      cols: "12",
      md: "4",
      lg: "4",
      xl: "4",
      sm: "4",
      validForm: true,
      optionSolution: [],
      checkbox1: null,
      checkbox2: null,
      headers: [
        { text: "Local", value: "local", width: 150, sortable: false },
        { text: "Sub local", value: "sub_local", width: 150, sortable: false },
        { text: "Tipo", value: "name", width: 130, sortable: false },
        { text: "Solução", value: "solution", width: 200, sortable: false },
        { text: "Categoria", value: "category", width: 150, sortable: false },
        { text: "Status", value: "status", width: 150, sortable: false },
        { text: "Quantidade", value: "amount", width: 100, sortable: false },
        { text: "Vazão Antes", value: "flowRateBefore", width: 130, sortable: false },
        { text: "Vazão Depois", value: "flowRateAfter", width: 130, sortable: false },
        { text: "Economia (%) ", value: "economy", sortable: false },
        { text: "Observação", value: "comments", sortable: false },
        { text: "Img", value: "Img", sortable: false },
        { text: "Ações", value: "action", sortable: false },
      ],
      checkListObj: [],
      optionsType: [
        { text: "Torneira", value: "faucet" },
        { text: "Chuveiro", value: "shower" },
        { text: "Descarga", value: "discharge" },
      ],
      dialogSolution: false,
      editableSolution: ObjectValidator.create('waterfix_checklist_solution'),
      editableSolutionIndex: null,
      operationType: 'edit',
      loading: {
        actionsSolutionList: false
      }, 
      solutionsData: [],
      pointsData: [],
      deleteItem: null,

    };
  },
  methods: {
    setOperationType(operationType = 'edit') {
      this.operationType = operationType
    },
    seteEditableSolutionIndex(index) {
      this.editableSolutionIndex = index;
    },
    async setSolutionReport(solution = null) {
      if (this.operationType == 'edit') {
        let _checkListObj = Utils.copyObject(this.checkListObj)
        _checkListObj[this.editableSolutionIndex] = Utils.copyObject(solution)
        this.checkListObj = _checkListObj
      } else if (this.operationType == 'register') {
        // this.checkListObj.unshift(Utils.copyObject(solution))
        this.checkListObj = [Utils.copyObject(solution), ...this.checkListObj]
      } else if (this.operationType == 'remove') {
        let _checkListObj = Utils.copyObject(this.checkListObj)
        _checkListObj = _checkListObj.filter((solution, index) => index !== this.editableSolutionIndex);
        this.checkListObj = _checkListObj
      }
      this.$emit('solution:update', this.checkListObj)
    },
    closeDialog(){
      this.dialogSolution = false
    }, 
    addSolutionReport() {
      this.editReportSolution()      
    },
    async updateSolutionList(solutionList){
        const {id} = await WaterFixService.getWaterFixProposalByRegister(this.registration)
        await WaterFixService.updateProposal(solutionList, id)
    },
    async confirmDeleteUnit(index) {
      this.seteEditableSolutionIndex(index)
      this.setOperationType('remove')
      showDeleteDialogAlert(`Deseja excluir esse item ${this.checkListObj[this.editableSolutionIndex].local}?`, this.setSolutionReport)
    },
    async deleteReportSolution() {
      const itemDelete = this.deleteItem
      if(itemDelete.imgNameList){
        for(let imgPath of itemDelete.imgNameList){
          await WaterFixStorage.deleteImg(imgPath)
        }
      }
      this.checkListObj = this.checkListObj.filter((solution) => solution !== itemDelete);
      this.optionSolution = this.optionSolution.filter((solution) => solution !== itemDelete);
      this.deleteItem = null
    },
    editReportSolution(index = null) {
      if (index === null) {
        this.editableSolution = ObjectValidator.create('waterfix_checklist_solution')
        this.seteEditableSolutionIndex(null)
        this.setOperationType('register')
      } else {
        this.editableSolution = Utils.copyObject(this.checkListObj[index])
        this.seteEditableSolutionIndex(index)
        this.setOperationType('edit')
      }
      this.dialogSolution = true
    },
    requestEvent() {
      this.$emit("update:info", this.checkListObj);
      if (this.$refs.formConsumption && !this.$refs.formConsumption.validate()) {
        showInfoSnackBar("Preencha os campos obrigatórios do checklist!")
        this.$emit("update:form", false);
        return;
      }else{
        this.$emit("update:form", true);            
      }
    },
    convertNameType(pointId){
      const type = this.pointsData.filter(({id}) => id == pointId)
      return type.length > 0?type[0].name : "Não Existe"
    },
    convertSolutionName(solutionId){
      const solutionFilter = this.solutionsData.filter(({id}) => id == solutionId)
      return solutionFilter.length > 0? solutionFilter[0].solution : "Não Existe"
    },
    async listSolutions(){
      this.solutionsData =  await SolutionsServices.GetSolutions()
    },
    async listPoints(){
      let pointIds = this.solutionsData.map((item) => item.type == 'Produto' ? item.pointId : null).filter((item) => item !== null && item !== undefined)
      let response =  await SolutionsPoint.GetSolutionsPointByIds(pointIds)
      this.pointsData = Object.values(response)
    },
    changeColorIconListImg(line) {
      if(line.imgNameList && line.imgNameList.length > 0){
        return "primary"
      }
      return ""
    },
  },
  computed: {
    rulesRequired() {
      return Rules.required();
    },
  },
  watch: {
    requestData() {
      this.requestEvent();
    },
    checkListObj() {
      this.requestEvent();
    },
    solutionListItens(){
      this.checkListObj = this.solutionListItens.map(
        (item) => {
          let solution = item
          if (!solution.hasOwnProperty('category')) {
            solution['category'] = null
          }
          if (!solution.hasOwnProperty('status')) {
            solution['status'] = null
          }
          return solution;
        }
      )
    }
  },
  async created(){
    await this.listSolutions()
    await this.listPoints()
  }
};
</script>